'use client';

import { Spinner, Stack } from '@chakra-ui/react';
import { notFound } from 'next/navigation';

import { getRoute } from '@/constants/route';
import { useJobGetQuery } from '@/modules/job/application';
import { JobDetail } from '@/modules/job/presentation/components';
import {
	jobDetailDtoToVM, useRemoveJobHandler, useSaveJobHandler,
} from '@/modules/job/view-models';
import { NextLinkButton } from '@/modules/navigation/presentation';

type JobDetailContainerProps = {
	jobId: string
};

export const JobDetailContainer = ({ jobId }: JobDetailContainerProps) => {
	const { data: job, isLoading } = useJobGetQuery(jobId);
	const saveJobHandler = useSaveJobHandler();
	const removeJobHandler = useRemoveJobHandler();

	if (isLoading) return <Spinner />;

	if (!job) return notFound();

	const jobDetail = jobDetailDtoToVM(job);

	return (
		<JobDetail.Root
			entryUrl={getRoute.jobs.apply(jobId)}
			handleAddInterestedJob={() => saveJobHandler.execute(jobId)}
			handleRemoveInterestedJob={() => removeJobHandler.execute(jobId)}
			job={jobDetail}
		>
			<Stack gap={8}>
				<JobDetail.Header />
				<JobDetail.JobDetail />
				<JobDetail.CompanyGallery />
				<JobDetail.SpecialInfo />
				<JobDetail.CompanyInformation />
				<JobDetail.HowToApply />
				<NextLinkButton
					disabled={jobDetail.hasApplied}
					href={jobDetail.hasApplied ? '#' : getRoute.jobs.apply(jobId)}
					mx="auto"
					size="xl"
					w="300px"
				>
					{jobDetail.hasApplied ? 'Applied' : 'Entry'}
				</NextLinkButton>
			</Stack>
		</JobDetail.Root>
	);
};
